export class FileUploadResult {
  fileId: string;
  fileName: string;
  UploadPath: string;
}
